import * as actionTypes from "./websiteAppearanceActionType";
import axios from "axios";
import { apiTimeout } from "./../error";

const { REACT_APP_API_URL } = process.env;

export const getWebsiteAppearance = () => {
    return (dispatch) => {
        dispatch(getWebsiteAppearanceInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/website-appearance/public`))
            .then((response) => {
                dispatch(getWebsiteAppearanceSuccess(response.data.data));
            }).catch(() => {
                dispatch(getWebsiteAppearanceFail());
            })
    }
}

const getWebsiteAppearanceInit = () => ({
    type: actionTypes.GET_WEBSITE_APPEARANCE,
})

const getWebsiteAppearanceSuccess = (data) => ({
    type: actionTypes.GET_WEBSITE_APPEARANCE_SUCCESS,
    payload: { data }
})

const getWebsiteAppearanceFail = () => ({
    type: actionTypes.GET_WEBSITE_APPEARANCE_FAILURE,
})
